<div class="efax-wizard">
  <div *ngFor="let item of wizardItems; index as i" class="efax-wizard__item">
    <button
      class="efax-wizard__button"
      [ngClass]="{
        active: activeStep === item,
        completed: i < wizardItems.indexOf(activeStep)
      }"
    >
      {{ item }}
    </button>

    <svg *ngIf="activeStep !== item" class="efax-wizard__item-bg">
      <use xlink:href="assets/img/wizard.svg#wizard-rec"></use>
    </svg>

    <svg *ngIf="activeStep === item" class="efax-wizard__item-bg">
      <use xlink:href="assets/img/wizard.svg#wizard-rec-active"></use>
    </svg>
  </div>
  <!-- /.efax-wizard__item -->
</div>
<!-- /.efax-wizard -->
